import { Box, Tooltip } from "@mui/material";
import { DateTime } from "luxon";
import { memo } from "react";
import type { EmploymentType, LeakageReportJob } from "../../utils/models";
import { getEmploymentTypeDisplayName } from "../../utils/utilFunctions";

const EMPTY = "—";

/** Right-aligned numeric cell formatted to two decimals. */
export const HoursCell = memo(function HoursCell({ value }: { value: number }) {
	return <Box sx={{ width: "100%", textAlign: "right" }}>{value.toFixed(2)}</Box>;
});

/** Whole-number cell (weekends worked), right-aligned. */
export const CountCell = memo(function CountCell({ value }: { value: number }) {
	return <Box sx={{ width: "100%", textAlign: "right" }}>{value}</Box>;
});

export const EmploymentTypeCell = memo(function EmploymentTypeCell({ value }: { value: EmploymentType }) {
	return <span>{getEmploymentTypeDisplayName(value)}</span>;
});

/** Comma-separated job list, ellipsized with a tooltip when it overflows. */
export const JobCell = memo(function JobCell({ value }: { value: LeakageReportJob[] }) {
	const text = value.length ? value.map((j) => j.displayName).join(", ") : EMPTY;
	return (
		<Tooltip title={text}>
			<Box sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{text}</Box>
		</Tooltip>
	);
});

/** Luxon date → localized short date, or an em-dash when the nurse never worked in range. */
export const LastShiftCell = memo(function LastShiftCell({ value }: { value: DateTime | null }) {
	if (!value?.isValid) return <span>{EMPTY}</span>;
	return <span>{value.toLocaleString(DateTime.DATE_MED)}</span>;
});
